import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, RouterProvider, createBrowserRouter} from 'react-router-dom';
import Router from './Presentation';
import GlobalStyl from './Presentation/Global';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from 'styled-components';
import theme from '@ds/components/bosons/Theme';
import {init as initApm} from '@elastic/apm-rum';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const apm = initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: 'admin-react',

  // Set custom APM Server URL (default: http://localhost:8200)
  serverUrl: 'https://apm.scaleup.com.br',

  // Set service version (required for sourcemap feature)
  serviceVersion: '',
});

const router = createBrowserRouter([{path: '*', element: <Root />}]);

function Root() {
  return (
    <>
      <GlobalStyl />
      <ThemeProvider theme={theme['light']}>
        <Router />
      </ThemeProvider>
    </>
  );
}
// <React.StrictMode>
root.render(<RouterProvider router={router} />);
// </React.StrictMode>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
